import { useRouter } from "next/router";
import { useMemo } from "react";

import FAQQuestionsView from "@/components/brandRefresh/faqs/faq-questions-view";
import { useSearchParams } from "next/navigation";

import FAQTopicView from "@/components/brandRefresh/faqs/faq-topic-view";
import { containsIgnoreCase } from "utils/new-helper";
const FAQContainer = ({ data }) => {
  const faqTopics = data?.faqs?.data ?? [];
  const { query } = useRouter();
  const { slug } = query;

  const searchParams = useSearchParams();
  const search = searchParams.get("search");

  const topic = slug[1] ? encodeURIComponent(slug[1]) : "";

  const faqQuestions = useMemo(() => {
    if (!topic || !faqTopics) return [];

    const filteredTopics = faqTopics.filter(
      ({ attributes }) => attributes.slug === topic,
    );

    if (filteredTopics.length > 0) {
      return filteredTopics[0].attributes.Questions; // Return questions if topic matches
    }

    const searchResults = faqTopics.flatMap(({ attributes }) =>
      attributes.Questions.filter(
        ({ Question, Answer }) =>
          containsIgnoreCase(Question, search) ||
          containsIgnoreCase(Answer, search),
      ),
    );
    return searchResults;
  }, [topic, faqTopics, search]);

  if (topic && !faqQuestions) return "No Result Found";

  return (
    <div className="flex flex-col text-sm md:text-base">
      {topic ? (
        <FAQQuestionsView questions={faqQuestions} faqTopics={faqTopics} />
      ) : (
        <FAQTopicView faqTopics={faqTopics} />
      )}
    </div>
  );
};

export default FAQContainer;
